import {
  HouseAvailabilityGlobalOutputDto,
  HouseAvailabilityICalendarOutputDto,
  HouseAvailabilityIndividualOutputDto,
  HouseContext,
  HouseOptionsGlobal,
  HouseOptionsIndividual,
  HousePriceTypeEnum,
} from '../../../../lib/graphql'

type HouseContextTyped<T extends 'global' | 'individual'> = NonNullable<
  Omit<HouseContext, 'options' | 'availabilities'> & {
    options: T extends 'global' ? HouseOptionsGlobal : HouseOptionsIndividual
    availabilities: T extends 'global'
      ? (
          | HouseAvailabilityGlobalOutputDto
          | HouseAvailabilityICalendarOutputDto
        )[]
      : (
          | HouseAvailabilityIndividualOutputDto
          | HouseAvailabilityICalendarOutputDto
        )[]
  }
>

export type HouseContextGlobal = HouseContextTyped<'global'>
export type HouseContextIndividual = HouseContextTyped<'individual'>

function assertHouseType(
  house: NonNullable<Pick<HouseContext, 'priceType'>>,
  priceType: HousePriceTypeEnum,
): house is
  | HouseContextIndividual
  | HouseContextGlobal extends HouseContextIndividual
  ? HouseContextIndividual
  : HouseContextGlobal {
  return house.priceType === priceType
}

export const isHouseGlobal = (
  house: NonNullable<Pick<HouseContext, 'priceType'>>,
): house is HouseContextGlobal => {
  return assertHouseType(house, HousePriceTypeEnum.GLOBAL)
}

export const isHouseIndividual = (
  house: NonNullable<Pick<HouseContext, 'priceType'>>,
): house is HouseContextIndividual => {
  return assertHouseType(house, HousePriceTypeEnum.INDIVIDUAL)
}
